import { createContext, use, type ReactNode } from 'react';
import type { WizardReducer } from './wizardReducer';

const EditFrequenciesContext = createContext<WizardReducer | null>(null);

export function EditFrequenciesContextProvider({
	children,
	...props
}: {
	children: ReactNode;
} & WizardReducer) {
	return <EditFrequenciesContext value={props}>{children}</EditFrequenciesContext>;
}

export function useEditFrequencies() {
	const context = use(EditFrequenciesContext);
	if (!context) {
		throw new Error('useEditFrequencies must be used within a EditFrequenciesContextProvider');
	}
	return context;
}
